import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CORRELATION_HEADER, newCorrelationId, recordFailedCall } from '../observability/correlation';

/**
 * OPS-02: sends a fresh X-Correlation-Id with every API call. When the server fails (5xx) or cannot be reached,
 * the id is kept so the error toast the screen shows next carries it ("Ref: …") for support.
 */
export const correlationInterceptor: HttpInterceptorFn = (req, next) => {
  const isApi = req.url.startsWith('/api/') || req.url.startsWith(environment.apiUrl);
  if (!isApi) return next(req);

  const id = req.headers.get(CORRELATION_HEADER) || newCorrelationId();
  const sent = req.headers.has(CORRELATION_HEADER) ? req : req.clone({ setHeaders: { [CORRELATION_HEADER]: id } });
  return next(sent).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && (error.status >= 500 || error.status === 0))
        recordFailedCall(error.headers?.get(CORRELATION_HEADER) || (error.error as any)?.CorrelationId || id);
      return throwError(() => error);
    })
  );
};
